import React, { useState, useEffect } from 'react'
import { AiOutlinePlusCircle,  AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import ToastNotification from '../../../components/ToastNotification';
import { FaEquals } from 'react-icons/fa';
import { MdEdit } from "react-icons/md";


const GodownMaster = () => {

   const [showAddForm, setShowAddForm] = useState(false);
   const[godownData,setGodownData] = useState({
    godown_name:'',
    godown_location:"",
   })

     const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };
    
    const [isEditMode, setIsEditMode] = useState(false);
     const [searchTerm, setSearchTerm] = useState('');
    const[fetchDetail,setFetchDetail] = useState([]);
     const [selectedItemId, setSelectedItemId] = useState("");

const [locations, setLocations] = useState([]); 
const [showLocationModal, setShowLocationModal] = useState(false);
const [newLocationName, setNewLocationName] = useState(""); 


    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setGodownData(prev => ({ ...prev, [name]: value }));
    };
      

 const handleEdit = (s) => {
        setGodownData({
            id: s.id,
           godown_name:s.godown_name || '',
            godown_location: s.godown_location || '',
          
        });

      
        setSelectedItemId(s.id);
        setIsEditMode(true);
        setShowAddForm(true);
 }


        
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            if (isEditMode) {
              
                 await axios.put(
                    `https://api.skyguard.group/api/update-godown/${godownData.id}`,
                    godownData
                   
                );
                showToast("Godown updated  successfully!", "success"); 
            } else {
                 await axios.post(
                    "https://api.skyguard.group/api/add-godown",
                    godownData
                   
                );
                showToast("Godown created  successfully!", "success"); 
            }
              setShowAddForm(false);
                fetchGodown();
            setIsEditMode(false);
            setGodownData({
               godown_name:'',
              godown_location:"",  
            })
        } catch (error) {
           console.error("❌ Error:", error.response?.data || error.message);
            showToast("Failed to create godown!", "danger"); 
        }
 }



const fetchGodown = async () => {
    try {
        const result = await axios.get('https://api.skyguard.group/api/fetch-godown');
        const sorted = Array.isArray(result.data)
            ? [...result.data].sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0))
            : result.data;

        // Extract only location names
        const locationList = sorted.map(item => item.godown_location);

        setLocations(locationList);
        setFetchDetail(sorted);

    } catch (error) {
        console.log(error)
    }
};



    useEffect(() => {
    fetchGodown();
       

    }, []);




      const filterIssue = fetchDetail.filter((tt) => {
        const term = searchTerm.toLowerCase();

        return (
            (tt. godown_name && tt. godown_name.toLowerCase().includes(term)) ||
            (tt. godown_location && tt. godown_location.toLowerCase().includes(term))
        );
    });

    return (
        <>
          <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                 <h3 className='my-3 fw-bold fs-5 golos'>Godown</h3>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />
                <div className="mb-3 row gx-2 gy-2 d-flex justify-content-between">


                    <div class="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                         <div className="col-md-4 ">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search By Godown Name"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                           




                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button
                                className={`btn ${showAddForm ? 'btn-danger' : 'btn-success'}`}
                                onClick={() => {
                                    setShowAddForm(!showAddForm);
                                    
                                }}
                            >
                                {showAddForm ? 'Cancel' : 'Add'}{' '}
                                {showAddForm ? <FaTimes size={18} /> : <AiOutlinePlusCircle size={20} />}
                            </button>
                        </div>

                    </div>





                </div>

                 {showAddForm && (
                    <div className='card p-3 mb-4'>
                        <h5 className="mb-3">Add New Godown</h5>
                        <form className='row g-3' onSubmit={handleSubmit} >

                                                {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {godownData.godown_name}
    </span>
  </div>
)}
                        <div className="col-md-4">
                                <laebl>Godown Name</laebl>
                                <input
                                    type="text"
                                    className="form-control"

                                    name="godown_name"
                                    value={godownData.godown_name}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-4">
                                <laebl>location</laebl>
                               
                            <select
    name="godown_location"
    className="form-control"
    value={godownData.godown_location}
    onChange={(e) => {
      if (e.target.value === "__add_new__") {
        setShowLocationModal(true);
      } else {
        setGodownData({ ...godownData, godown_location: e.target.value });
      }
    }}
  >
    <option value="">-- Select Location --</option>
    {locations.map((loc, index) => (
      <option key={index} value={loc}>
        {loc}
      </option>
    ))}
    <option value="__add_new__">➕ Add New Location</option>
  </select>

                            </div>

                            {showLocationModal && (
  <div className="modal show d-block" tabIndex="-1">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Add New Location</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowLocationModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <input
            type="text"
            className="form-control"
            placeholder="Enter location name"
            value={newLocationName}
            onChange={(e) => setNewLocationName(e.target.value)}
          />
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              setNewLocationName("");
              setShowLocationModal(false);
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => {
              if (!newLocationName.trim()) return;

              // ✅ Add new location to list
              setLocations([...locations, newLocationName]);

              // ✅ Update selected godown location
              setGodownData({
                ...godownData,
                godown_location: newLocationName,
              });

              // reset + close
              setNewLocationName("");
              setShowLocationModal(false);
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
)}

                           

                            <div className="col-md-12 d-grid d-flex justify-content-end">
                             
                                <button type="submit" className='btn btn-success w-10'>
                                    {isEditMode ? "Update" : "Save"}
                                </button>
                                <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                    setShowAddForm(false);
                                    setIsEditMode(false);
                                    setGodownData({
                                         godown_name:'',
                                       godown_location:"",
                                    })
                                }}>
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                )}


   <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className='table table-bordered table-striped table-hover text-center align-middle'>
                        <thead className='table-info'>
                            <tr>
                                <th scope='col'>SN</th>
                                   <th scope='col'>Action</th>
                                <th scope='col'>Godown Name</th>
                                <th scope='col'>Location</th>
                               
                               
                            </tr>
                        </thead>
                        <tbody>
                           {filterIssue.map((s, idx) => (
                                                             <tr key={idx}>
                                                                 <td>{idx + 1}</td>
                                                                    <td>
                                                                     <button type="button"
                                                                         className='btn btn-primary mx-2'
                                                                         onClick={() => handleEdit(s)}
                         
                                                                     >
                         
                                                                         <AiOutlineEdit size={20} title='Edit' />
                                                                     </button>
                                                                 </td>
                                                                 <td>{s.godown_name}</td>
                                                                 <td>{s.godown_location}</td>
                                                             
                         
                                                              
                                                             </tr>
                         
                         
                         
                                                         ))}
                        

                        </tbody>
                    </table>
                </div>
   
            </div>
          </div>
        </>
    )
}
export default GodownMaster